import { selectFromUserInviteSubscription } from '../models';
import UserInviteQuery from '../queries/userInvite/UserInviteQuery';
import { SubscriptionHandler } from '../utils/createSubscription';
import userInviteAcceptedHandler from './handlers/account/userInviteAcceptedHandler';
import userInviteRevokedHandler from './handlers/account/userInviteRevokedHandler';

const selector = selectFromUserInviteSubscription()
  .userInviteAcceptedDto(b => b.userInvite(UserInviteQuery))
  .userInviteCreatedDto(b => b.userInvite(UserInviteQuery))
  .userInviteRevokedDto(b => b.inviteUuid)
  .toString();

export default (): SubscriptionHandler => ({
  name: 'UserInviteSubscription',
  selector,
  events: new Map(Object.entries({
    UserInviteAcceptedDto: [userInviteAcceptedHandler],
    UserInviteRevokedDto: [userInviteRevokedHandler],
  })),
  onError(error: Error) {
    console.error('UserInviteSubscription Error, check if websocket client initialized', JSON.stringify(error));

  },
});
